import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Bell, BellOff } from "lucide-react";

export default function FollowButton({ organizerId, initialFollowing, initialCount, onChange, compact = false }) {
  const { user } = useAuth();
  const nav = useNavigate();
  const [following, setFollowing] = useState(!!initialFollowing);
  const [busy, setBusy] = useState(false);

  const toggle = async () => {
    if (!user) { nav("/login", { state: { from: window.location.pathname } }); return; }
    setBusy(true);
    try {
      const { data } = following ? await api.delete(`/organizers/${organizerId}/follow`) : await api.post(`/organizers/${organizerId}/follow`);
      setFollowing(data.following); onChange?.(data.following, data.followers);
      toast.success(data.following ? "Following — we'll email you when they drop a new event" : "Unfollowed");
    } catch (e) { toast.error(formatApiError(e)); }
    finally { setBusy(false); }
  };

  return (
    <button data-testid="follow-btn" onClick={toggle} disabled={busy}
      className={`inline-flex items-center gap-2 rounded-full font-bold transition ${compact ? "px-3 py-1 text-xs" : "px-5 py-2.5 text-sm"} ${following ? "border border-zinc-700 bg-transparent text-zinc-200 hover:border-red-500/60 hover:text-red-300" : "bg-blush text-[#3a0d1a] hover:bg-rose hover:text-white"}`}>
      {following ? <><BellOff className="h-4 w-4" /> Following</> : <><Bell className="h-4 w-4" /> Follow</>}
    </button>
  );
}
